import { Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';




@Component({
    selector: 'app-iframe',
    templateUrl: './iframe.html'


})
export class Iframe {
    videoUrl: string;

    constructor(protected _sanitizer: DomSanitizer, public dialogRef: MatDialogRef<Iframe>, @Inject(MAT_DIALOG_DATA) public data) {
        console.log()
        this.videoUrl = data.link
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    photoURL(url) {
        if (url != undefined)
            return this._sanitizer.bypassSecurityTrustResourceUrl(url);
        else 
            return this._sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    }
}

